import "./About.css";

export default function About() {
  // Set title bar - nice for looking at history:
  document.title = "Mars Rovers: About";

  return (
    <div id="about">
      <p>This web application derives data from the Mars Photo API maintained by chrisccerami.</p>
      <p>Explore the <a href="https://github.com/chrisccerami/mars-photo-api">official repository</a>.</p>
      <p>
        This project was forked from Peyton's at {" "}
        <a
          href="https://github.com/pekellogg/react-app"
          target="_blank"
          rel="noreferrer"
          >
          her Github repo
        </a>.
      </p>
      <h1>TODO</h1>
      <ul style={{marginLeft:"1rem"}}>
        <li>
          Routing issues when built for a subdirectory in document root which
          is not the root of a vhost.
          <br />Works fine, looks odd (relative path replaced by routes).
        </li>
        <li>
          CSS is (still, though less so) an utter mess - i.e. this item list,
          margin is broken with both
          <code>&lt;ul&gt;</code> or <code>&lt;ol&gt;</code>.
          <br />(Work-around: inline style applied)
        </li>
        <li>
          <strike>Initial landing page does not reflect current route via highlighted
          menu / navbar tab.</strike>
        </li>
      </ul>

      <br />
      <hr />
      <br />

      <figure style={{textAlign:"center"}}>
        <figcaption style={{marginBottom:"1rem"}}>
          <a href="https://xkcd.com/695/"
            target="_blank"
            rel="noreferrer"
            >
            Obligatory xkcd
          </a> entitled "<b><i>Spirit</i></b>" (a Very Good Rover):
        </figcaption>
        <img src="https://imgs.xkcd.com/comics/spirit.png"
          alt="XKCD: Mars Rover Spirit: A Good Rover"
          style={{maxWidth:"75vw"}}
          />
      </figure>
    </div>
  );
};
